<template>
    <v-container class="container" fluid>
        <v-card>
            <v-toolbar dense dark color="secondary" v-if="onlyShow != true">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Site Readings</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <div v-if="readings == ''" class="text-center align-md-content-center">
                <v-progress-circular :size="30" :width="5" color="primary" class=" my-5"
                    indeterminate></v-progress-circular>
            </div>
            <v-row v-if="readings != ''" class="mx-5 mt-1">
                <v-col cols="12">
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Site #</th>
                                <th>Tank #</th>
                                <th>Product</th>
                                <th>Volume</th>
                                <th>SafeFill</th>
                                <th>Ullage</th>
                                <th>Reading Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in readings" :key="item.TankNum" :v-model="item.active">
                                <td style="text-align: left;">
                                    {{ item.SiteNum }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.TankNum }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.Product }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.Volume }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.Safefill }}
                                </td>
                                <td style="background: #F9f2aa;font-style: bold;text-align: left;">
                                    <strong>{{ item.Ullage }}</strong>
                                </td>
                                <td style="text-align: left;">
                                    {{ item.DateTime }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row v-show="readings != ''" class="mx-5" v-if="onlyShow != true">
                <v-col cols="12" class="p-5">
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Volume</th>
                                <th>Ullage</th>
                                <th>Daily Average</th>
                                <th>Stat AvgDaily</th>
                                <th>RO Hrs</th>
                                <th>NRO Hrs</th>
                                <th>Safe Fill</th>
                                <th v-if="onlyShow != true">
                                    Product Code
                                    <v-btn small icon @click="getMtxCode(products)"><v-icon>mdi-reload</v-icon></v-btn>
                                </th>
                                <th v-if="onlyShow != true">
                                    Auto Quantity
                                    <v-btn small icon
                                        @click="refreshToOldQuantities()"><v-icon>mdi-reload</v-icon></v-btn>
                                </th>
                                <th>
                                    <v-tooltip top></v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small icon v-on="on" v-bind="attrs"
                                                @click="copyAllAutoQuantitytoQuantity()">
                                                <v-icon>mdi-arrow-right</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Copy all Auto Quantities to Quantities</span>
                                    </v-tooltip>
                                </th>
                                <th v-if="onlyShow != true">Quantity</th>
                                <th v-if="onlyShow != true">RT Hrs</th>
                                <th v-if="onlyShow != true">NRT Hrs</th>
                            </tr>
                        </thead>
                        <tbody ref="orderQuantities">
                            <tr v-for="(item, index) in products" :key="item.Product" :v-model="item.active">
                                <td style="text-align: left;">
                                    {{ item.Product }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.Volume }}
                                </td>
                                <td style="background: #F9f2aa;font-style: bold;text-align: left;">
                                    <strong>{{ item.Ullage }}</strong>
                                </td>
                                <td style="text-align: left;">
                                    {{ item.AvgDaily }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.StatAvgDaily }}
                                </td>
                                <td style="text-align: left;">
                                    {{ item.ROHrs }}
                                </td>
                                <td style="text-align: left;">
                                    {{ calculateNRO(item) }}
                                </td>

                                <td style="text-align: left;">
                                    {{ item.SafeFill }}
                                </td>
                                <td v-if="onlyShow != true" style="text-align: left;">
                                    <v-text-field v-model="item.ProductCode" dense hide-details></v-text-field>
                                </td>
                                <td v-if="onlyShow != true" style="text-align: left;">
                                    <v-text-field v-model="item.suggested_quantity.dispatched_volume" type="number"
                                        :rules="[
                                            (!isNaN(parseFloat(v)) &&
                                                v >= 0) ||
                                            'Only numbers are allowed'
                                        ]" dense hide-details autofocus></v-text-field>
                                </td>
                                <td>
                                    <v-tooltip top></v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small icon v-on="on" v-bind="attrs"
                                                @click="copyAutoQuantitytoQuantity(index)">
                                                <v-icon>mdi-arrow-right</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Copy Auto Quantity({{ item.suggested_quantity.dispatched_volume }}) to
                                            Quantity</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="onlyShow != true" style="text-align: left;">
                                    <v-text-field v-model="item.Quantity" type="number" :rules="[
                                        (!isNaN(parseFloat(v)) &&
                                            v >= 0) ||
                                        'Only numbers are allowed'
                                    ]" dense hide-details autofocus></v-text-field>
                                </td>
                                <td style="text-align: left;">
                                    {{ item.RTHrs }}
                                </td>
                                <td style="text-align: left;">
                                    {{ NRTHrs[index] }}
                                </td>
                            </tr>
                            <tr v-if="onlyShow != true">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align: left;">
                                    <v-text-field disabled hide-details dense v-model="orderTot"></v-text-field>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'SiteReadings',
    props: ['onlyShow', 'valores'],
    data: function () {
        return {
            readings: [],
            products: [],
            productsPrm: [],
            pdCode: [],
            dataLoading: false,
            total: 0
        };
    },

    mounted() {
        console.log('Props: ', this.onlyShow, this.valores);
        console.log('SiteNum: ', this.$store.state.siteReadings.SiteNum);
        this.loadSiteReadings(this.$store.state.siteReadings.SiteNum);
        this.loadProductTotals(this.$store.state.siteReadings.SiteNum);
        this.scrollIntoView();
    },
    watch: {
        '$store.state.siteReadings.SiteNum': function () {
            (this.readings = []),
                (this.products = []),
                this.loadSiteReadings(this.$store.state.siteReadings.SiteNum);
            this.loadProductTotals(this.$store.state.siteReadings.SiteNum);
        }
    },

    computed: {
        NRTHrs() {
            return this.products.map((item) => this.calculateRT(item.Quantity, item.RTHrs, item.AvgHourly));
        },
        RTHrs() {
            return this.products.map((item) => this.calculateRT(item.Quantity, item.RTHrs, item.AvgHourly));
        },
        orderTot() {
            return this.products.reduce(getOrderTotal, 0);

            function getOrderTotal(total, item) {
                var q = parseInt(item.Quantity);
                if (isNaN(q)) {
                    return total + 0;
                } else {
                    return total + q;
                }
            }
        }
    },

    methods: {
        calculateRT(Quantity, RTHrs, AvgHourly) {
            const quantity = isNaN(Number(Quantity)) ? 0 : Number(Quantity);
            const RTHr = isNaN(Number(RTHrs)) ? 0 : Number(RTHrs);
            return Math.round(RTHr + (quantity / AvgHourly))
        },
        copyDispatchedToQuantity(index) {
            const product = this.products[index];
            product.Quantity = Number(product.suggested_quantity.dispatched_volume);
        },

        copyAutoQuantitytoQuantity(index) {
            this.copyDispatchedToQuantity(index);
        },

        copyAllAutoQuantitytoQuantity() {
            this.products.forEach((_, index) => {
                this.copyDispatchedToQuantity(index);
            });
        },

        refreshToOldQuantities() {
            this.products.forEach(product => {
                product.suggested_quantity.dispatched_volume = Number(product.autoQuantity);
            });
        },
        calculateNRO: function (item) {
            const quantity = isNaN(Number(item.Quantity)) ? 0 : Number(item.Quantity);
            const avgHourly = Number(item.AvgHourly);
            const roh = Number(item.ROHrs);


            let newRunoutTime;

            if ((roh === 0 || roh === "" || roh === null) && quantity !== 0) {
                newRunoutTime = Math.round(quantity / avgHourly);
            } else if (roh === 0 && quantity === 0) {
                newRunoutTime = roh;
            } else {
                const runout = Math.round(quantity / avgHourly);
                newRunoutTime = Math.round(runout + roh);
            }

            return newRunoutTime;
        },

        getMtxCode: async function (item) {
            var params = {
                Customer: this.valores.Customer,
                Terminal: this.valores.Terminal,
                Supplier: this.valores.Supplier,
                Products: item
            };
            await axios
                .post('get-product-code-number/mtx', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = [];
                    this.products = response.data;
                    this.products = this.products.map(product => ({
                        ...product,
                        autoQuantity: product.suggested_quantity.dispatched_volume,
                        Quantity: 0,
                    }));
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        loadSiteReadings: function (stationID) {
            (this.readings = []), (this.dataLoading = true);
            this.$store.state.isLoading = true;
            console.log(stationID);
            if (stationID != '') {
                axios
                    .get('ftp-readings/reads/station/' + stationID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);

                        // Ordenamiento tipo burbuja para los readings

                        let temporalReadings = response.data;
                        let l = temporalReadings.length;
                        let aux;

                        for (let i = 1; i < l; i++) {
                            for (let r = 0; r < l - i; r++) {
                                if (
                                    temporalReadings[r].TankNum >
                                    temporalReadings[r + 1].TankNum
                                ) {
                                    aux = temporalReadings[r];
                                    temporalReadings[r] =
                                        temporalReadings[r + 1];
                                    temporalReadings[r + 1] = aux;
                                }
                            }
                        }

                        console.log('Temporal Readings', temporalReadings);
                        this.readings = temporalReadings;
                        console.log(this.readings);
                        this.dataLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            this.$store.state.isLoading = false;
        },
        loadProductTotals: function (stationID) {
            this.dataLoading = true;
            (this.products = []), (this.$store.state.isLoading = true);
            console.log(stationID);
            if (stationID != '') {
                axios
                    .get('ftp-readings/reads/station/t/' + stationID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        await response.data.forEach(elm => {
                            elm.ProductCode = 0;
                        });
                        console.log(response.data);
                        this.getMtxCode(response.data);

                        this.dataLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            this.$store.state.isLoading = false;
            console.log(this.readings);
        },
        scrollIntoView() {
            const element = this.$refs.orderQuantities;
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth', // Hace el scroll suave
                    block: 'start', // Ajusta la posici�n vertical del scroll (start, center, end, nearest)
                    inline: 'start' // Ajusta la posici�n horizontal del scroll (start, center, end, nearest)
                });
                console.log(element);
            }
        }
    }
};
</script>
